module.exports = __webpack_public_path__ + "static/media/12.Sugarcane juice Machine Indian.cf56bc9e.jpg";